import axiosInstance from '@/Utils/axiosInstance';
import axios from 'axios';

function formatPhoneNumber(identifier) {
  const cleaned = identifier.replace(/\D/g, '');

  // Egyptian numbers: 010, 011, 012, 015 (11 digits total)
  const egyptRegex = /^(010|011|012|015)\d{8}$/;

  // Saudi numbers: starts with 05 and total 10 digits
  const saudiRegex = /^05\d{8}$/;

  if (egyptRegex.test(cleaned)) {
    return `+2${cleaned}`;
  }

  if (saudiRegex.test(cleaned)) {
    return `+966${cleaned.substring(1)}`; // remove leading 0
  }

  return null; // invalid number
}

export const ProfileSettingsService = {
  sendOTP: async ({ identifier, identifierType = 'mobile' }) => {
    try {
      const mobileNumber = formatPhoneNumber(identifier);
      const response = await axios.post(
        `${import.meta.env.VITE_DRU_PATIENT_APP_BASE_URL}/otp/send_otp`,
        {
          identifier: mobileNumber || identifier,
          identifier_type: identifierType,
        },
        {
          headers: {
            'x-access-key': `${import.meta.env.VITE_REACT_APP_X_ACCESS_KEY}`,
            Authorization: localStorage.getItem('token'),
            lang: localStorage.getItem('language') || 'en',
            notification_via_slack: false,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error sending OTP:', error);
      throw error?.response?.data || { message: 'Unknown error occurred while sending OTP' };
    }
  },
  verifyOTP: async ({ identifier, password }) => {
    try {
      const mobileNumber = formatPhoneNumber(identifier);
      const response = await axios.post(
        `${import.meta.env.VITE_DRU_PATIENT_APP_BASE_URL}/otp/verify_otp`,
        {
          identifier: mobileNumber || identifier,
          password,
        },
        {
          headers: {
            'x-access-key': `${import.meta.env.VITE_REACT_APP_X_ACCESS_KEY}`,
            Authorization: localStorage.getItem('token'),
            lang: localStorage.getItem('language') || 'en',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error?.response?.data || { message: 'Unknown error occurred while verifying OTP' };
    }
  },
  checkExistingMobile: async () => {
    try {
      const response = await axiosInstance.get('/doctorsappuser/check-existing-mobile', {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: localStorage.getItem('language') || 'en',
        },
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  },
  addMobileNumber: async (data) => {
    try {
      const response = await axiosInstance.post('/doctorsappuser/add-mobile-number', data, {
        headers: {
          Authorization: localStorage.getItem('token'),
          lang: localStorage.getItem('language') || 'en',
        },
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  },
};
